
import { VehicleLayout } from "@/components/vehicle/VehicleLayout";
import { VehicleRegistrationForm } from "@/components/vehicle/VehicleRegistrationForm";

const VehicleRegistration = () => {
  return (
    <VehicleLayout title="Register Your Fleet">
      <VehicleRegistrationForm />
    </VehicleLayout>
  );
};

export default VehicleRegistration;
